// eslint-disable-next-line no-unused-vars
import * as React from "react";
import { MenuItem as MuiMenuItem, styled } from "@mui/material";

export const MenuItem = styled(MuiMenuItem)(
    ({ theme }) => `
        &.Mui-selected { 
            border-right: 3px solid ${theme.palette.primary.main}; 
        }
    `
);
